import _classCallCheck from "c:\\repo\\maketek-company-website\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "c:\\repo\\maketek-company-website\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "c:\\repo\\maketek-company-website\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "c:\\repo\\maketek-company-website\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "c:\\repo\\maketek-company-website\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import _assertThisInitialized from "c:\\repo\\maketek-company-website\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/assertThisInitialized";

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React from 'react';
import withNavigation from './withNavigation';
var EventNameToPropName = {
  willFocus: 'onWillFocus',
  didFocus: 'onDidFocus',
  willBlur: 'onWillBlur',
  didBlur: 'onDidBlur'
};
var EventNames = Object.keys(EventNameToPropName);

var NavigationEvents =
/*#__PURE__*/
function (_React$Component) {
  _inherits(NavigationEvents, _React$Component);

  function NavigationEvents() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, NavigationEvents);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(NavigationEvents)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getPropListener", function (eventName) {
      return _this.props[EventNameToPropName[eventName]];
    });

    return _this;
  }

  _createClass(NavigationEvents, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.subscriptions = {}; // We register all navigation listeners on mount to ensure listener stability across re-render
      // A former implementation was replacing (removing/adding) listeners on all update (if prop provided)
      // but there were issues (see https://github.com/react-navigation/react-navigation/issues/5058)

      EventNames.forEach(function (eventName) {
        _this2.subscriptions[eventName] = _this2.props.navigation.addListener(eventName, function () {
          var propListener = _this2.getPropListener(eventName);

          return propListener && propListener.apply(void 0, arguments);
        });
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this3 = this;

      EventNames.forEach(function (eventName) {
        _this3.subscriptions[eventName].remove();
      });
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return NavigationEvents;
}(React.Component);

export default withNavigation(NavigationEvents);